import { FC } from "react";
import { DialogData, DialogHandle } from "../../types";
import { _ } from "../../utils/helpers";
import { DEFAULT_DIALOG_HANDLE, translator} from "../../utils/symbols";
import { SafeImage } from "../../parts/SafeImage";
import { Icon } from "../../parts/Icon";
import { useApp } from "../../context/useApp";

interface ProductDialogProps {
    dialogData: DialogData
}

export const ProductDialog: FC<ProductDialogProps> = ({dialogData}) => {

    const {state: {
        dialogHandles
    }} = useApp()

    if (dialogData.dialog !== 'product') return null

    const dialogHandle:DialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    return (
        <section 
            className={`df fd-c aifs jcfs r3 section p-r product-dialog`}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            {
                dialogData.img && (
                    <SafeImage src={dialogData.product.icon} alt={dialogData.product.name} className="img"/>
                )
            }
            
            <h2 id="dialog-title" className="text s18-500 my-8 w-fc ml-8 zone-name r3" dangerouslySetInnerHTML={{__html: translator.extractTranslationFromString(dialogData.product.name)}}></h2>
            <p id="dialog-description" className="text s18-400 mb-8 px-8" dangerouslySetInnerHTML={{__html: translator.extractTranslationFromString(dialogData.product.description)}}></p>
            <button 
                className="button b-0 p-2 p-a zi-6 close df aic jcc"
                onClick={() => dialogHandle.closeDialog()}
            >
                <Icon icon="close"/>
            </button>
        </section>
    )
}